import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useCart } from "../Context/CartContext";
import "./Shop.css";
import BASE_URL from "../config";

function Shop() {

  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const location = useLocation();

const searchParams = new URLSearchParams(location.search);
const search = searchParams.get("search")?.toLowerCase() || "";
 useEffect(() => {

  fetch(`${BASE_URL}/api/products/allproducts`)
    .then(res => res.json())
    .then(data => {

      console.log(data); // pehle ye check karo

      setProducts(data.products);

    })
    .catch(err => console.log(err));

}, []);
const filteredProducts = products.filter((product) =>
  product.name.toLowerCase().includes(search)
);

  return (
    <div className="shop-container">

      <h1 className="shop-title-color">
        CRAFTED FOR THE JOURNEY
      </h1>

      <div className="products-grid">

  {filteredProducts.length > 0 ? (

  filteredProducts.map((product) => (
    <div
      className="product-card"
      key={product.id}
      onClick={() => navigate(`/product/${product.id}`)}
    >
      <img
        src={`https://sahscents.store/uploads/${product.image}`}
        alt={product.name}
      />

      <h3>{product.name}</h3>

      <p>AED {product.price}</p>

      <button
        onClick={(e) => {
          e.stopPropagation();

          addToCart(product, 1);

          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: `${product.name} added to cart`,
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }}
      >
        Add To Cart
      </button>
    </div>
  ))

) : (

  <h2 style={{ color: "#fff", textAlign: "center", width: "100%" }}>
    No products found.
  </h2>

)}

      </div>

    </div>
  );
}

export default Shop;